import React, { useEffect, useState } from 'react';
import { BeatLoader } from 'react-spinners';
import HeroSection from '../components/Event/HeroSection';
import CountdownSection from '../components/Event/CountdownSection';
import GallerySection from '../components/Event/GallerySection';
import Footer from '../components/Event/Footer';
import { getActivityDetails } from '../api/activities';

const EventPage = ({ activityType, id }) => {
  const [eventData, setEventData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  const imageURLs = [
    'https://ipvision.id/assets/gallery/tayo.jpg',
    'https://ipvision.id/assets/gallery/pororo.jpg',
    'https://ipvision.id/assets/gallery/bluey.jpg',
  ];

  useEffect(() => {
    const fetchEventData = async () => {
      try {
        setLoading(true);
        const response = await getActivityDetails(id);
        
        if (!response.success) {
          throw new Error(response.error || 'Failed to fetch event data');
        }
        
        setEventData(response.data);
        setTimeout(() => setIsVisible(true), 100);
      } catch (err) {
        console.error('Error fetching event data:', err);
        setError(err.message || 'Failed to load event data');
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchEventData();
    }
  }, [id]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100">
        <div className="text-center">
          <div className="mb-6">
            <BeatLoader
              color="#3b82f6"
              loading={loading}
              size={15}
              aria-label="Loading event data"
            />
          </div>
          <p className="text-slate-600 font-medium">Loading event details...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 p-8">
        <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center border border-slate-200">
          <div className="w-16 h-16 mx-auto mb-4 bg-red-100 rounded-full flex items-center justify-center">
            <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h2 className="text-xl font-semibold text-slate-900 mb-2">Unable to Load Event</h2>
          <p className="text-slate-600 mb-4">{error}</p>
          <button
            onClick={() => window.location.reload()}
            className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors"
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  if (!eventData) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 p-8">
        <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center border border-slate-200">
          <div className="w-16 h-16 mx-auto mb-4 bg-amber-100 rounded-full flex items-center justify-center">
            <svg className="w-8 h-8 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
            </svg>
          </div>
          <h2 className="text-xl font-semibold text-slate-900 mb-2">Event Not Found</h2>
          <p className="text-slate-600">The requested event could not be found or may no longer be available.</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`min-h-screen bg-white transition-opacity duration-500 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
      <HeroSection eventData={eventData} activityType={activityType} activityId={id} />
      <CountdownSection eventData={eventData} />
      <GallerySection eventData={eventData} imageURLs={imageURLs} />
      <Footer />
    </div>
  );
};

export default EventPage;